import React, { useState } from 'react';
import { Button } from 'antd';
import { ArrowDownIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { IAllUniversities } from 'modules/universities';

interface IProps {
  university?: IAllUniversities;
}

const InfoSection: React.FC<IProps> = ({ university }) => {
  const [expanded, setExpanded] = useState(false);
  const t = useTranslations();

  const text = university?.long_description || university?.description || '';

  return (
    <div className="rounded-xl bg-white p-4">
      <h3 className="text-lg font-medium">{t('toliqroq_malumot')}</h3>

      {university?.youtube_embed && (
        <iframe
          width="100%"
          src={university.youtube_embed}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="md:h-120 my-3 h-48 rounded-lg sm:h-80"
        />
      )}

      <div className="relative mt-3 text-gray-600">
        <p className={`transition-all duration-300 ${expanded ? '' : 'line-clamp-8'}`}>{text}</p>

        {text.length > 300 && !expanded && (
          <div className="pointer-events-none absolute bottom-4 left-0 right-0 h-40 bg-gradient-to-t from-white to-transparent" />
        )}

        {text.length > 300 && (
          <div className="mt-2 flex justify-center">
            <Button type="link" onClick={() => setExpanded(!expanded)} className="p-0">
              {expanded ? t('malumotni_qisqartirish') : t('koproq_korsatish')}
              <div className="text-link mt-1" style={{ transform: `rotate(${expanded ? '180deg' : '0deg'})` }}>
                <ArrowDownIcon />
              </div>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoSection;
